import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

import { withListingContext } from "../listing-detail/ListingContext";

type Props = {
  classes: Object,
  className: string,
  filters: {
    zipCode?: string,
    city?: string,
    state?: string,
  },
};

const OnboardNavigator = ({ classes, className, filters }: Props) => {
  let src = `https://www.onboardnavigator.com/1.5/webcontent/OBWC_results.aspx?&AID=761-ee44178f74d0${
    filters.zipCode ? `&Zip=${filters.zipCode}` : ""
  }${filters.state ? `&state=${filters.state}` : ""}${
    filters.city ? `&City=${filters.city}` : ""
  }&Searchtype=1&Datatype=1&Frame=0&Width=800&Height=600`;
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.title}>Community / School Information</div>
      <div className={classes.paper}>
        <iframe
          className={classes.iframe}
          id="communityInfoIframe"
          src={src}
          title="Community / School Information"
          name="communityInfoIframe"
        />
      </div>
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "none",
    width: "100%",
    maxWidth: "872px",
    margin: "48px auto 96px auto",

    [theme.breakpoints(900)]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  title: {
    color: theme.colors.gray["800"],
    fontSize: "18px",
    lineHeight: "1",
    fontWeight: "600",
    textTransform: "uppercase",
    textAlign: "center",
    marginBottom: theme.spacing.unit * 0.75,
  },
  paper: {
    width: "100%",
    background: "#fff",
    borderRadius: theme.globalBorderRadius,
    boxShadow:
      "0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)", // material-design 1dp
    ...theme.globalPadding,
  },
  iframe: {
    width: "100%",
    minHeight: "800px",
  },
}))(withListingContext(OnboardNavigator));
